import { documentsFiltersConfig } from "../../constants/documentsFiltersConfig"
import { FILTERS, FILTERS_SEARCH_PARAM_PREFIX } from "../../constants/filters"

export function setFiltersSearchParams(filters, setParam, deleteParam) {
    Object.entries(filters || {}).forEach(([filterKey, filterValue]) => {
        const filterParam = documentsFiltersConfig[filterKey].getUrlParams(filterValue)
        if (filterValue?.length) {
            setParam(`${FILTERS_SEARCH_PARAM_PREFIX}${filterKey}`, filterParam)
        } else {
            deleteParam(`${FILTERS_SEARCH_PARAM_PREFIX}${filterKey}`)
        }
    })
}

export function deleteSearchParamsByKeys(searchParams, keysToDelete) {
    const matchKey = function (key, keyToMatch) {
        return key === keyToMatch
            || keyToMatch === "*"
            || (keyToMatch.endsWith("*") && key.startsWith(keyToMatch.substring(0, keyToMatch.length - 1)))
    }

    Array.from(searchParams.entries()).forEach(([key]) => {
        for (const keyToDelete of keysToDelete) {
            if (matchKey(key, keyToDelete)) {
                searchParams.delete(key)
                break
            }
        }
    })
    return searchParams
}

export function getQueryParamsFromFilters(filters, locale, dateFormatter, userIsStaff) {
    return Object.entries(filters || {}).reduce((acc, [filterKey, filterValue]) => {
        const params = documentsFiltersConfig[filterKey].getQueryParams(filterKey, filterValue, locale, dateFormatter, userIsStaff)
        if (params) {
            params.forEach(param => {
                acc = {
                    ...acc,
                    [param.name]: param.value,
                }
            })
        }
        return acc
    }, {})

}

export function getFiltersFromSearchParams(getParams) {
    const acceptedFiltersKeys = FILTERS
    return Array.from(getParams().entries()).reduce((acc, [key, value]) => {
        if (key.includes(FILTERS_SEARCH_PARAM_PREFIX)) {
            const filterKey = key.replace(FILTERS_SEARCH_PARAM_PREFIX, "")
            if (!acceptedFiltersKeys.includes(filterKey)) {
                return acc
            }

            return ({
                ...acc,
                [filterKey]: documentsFiltersConfig[filterKey].getValuesFromUrlParams(value),
            })
        }
        return acc
    }, {})
}

export function getSearchParamsFromFilters(filters) {
    return Object.entries(filters).reduce((acc, [key, value]) => {
        if (value?.length === 0 || value === null || value === undefined) {
            return acc
        }
        return ({
            ...acc,
            ...(value && { [FILTERS_SEARCH_PARAM_PREFIX + key]: value }),
        })
    }, {})
}